import { useTranslation } from "react-i18next";
import { useAppSelector } from "../hooks";
import { useMemo } from "react";

export const useAlert = () => {
  const alert = useAppSelector(({ common }) => common.alert);

  return {
    data: alert,
  };
};

export const useSuccessStatus = () => {
  const { t } = useTranslation();

  const updateUserNameStatus = useAppSelector(
    ({ auth }) => auth.updateUserNameStatus
  );

  const updateEmailStatus = useAppSelector(
    ({ auth }) => auth.updateEmailStatus
  );

  const linkGoogleStatus = useAppSelector(({ auth }) => auth.linkGoogleStatus);

  const linkAppleStatus = useAppSelector(({ auth }) => auth.linkAppleStatus);

  const setMyEmailPasswordStatus = useAppSelector(
    ({ auth }) => auth.setMyEmailPasswordStatus
  );
  const changMyPasswordStatus = useAppSelector(
    ({ auth }) => auth.changMyPasswordStatus
  );

  const removeDownloadsStatus = useAppSelector(
    ({ settings }) => settings.removeMultiDownloads
  );

  const createPlaylistStatus = useAppSelector(
    ({ myLibrary }) => myLibrary.createPlaylist.status
  );

  const addItemToPlaylistStatus = useAppSelector(
    ({ myLibrary }) => myLibrary.addItemToPlaylist.status
  );

  const arrangePlaylistItemsStatus = useAppSelector(
    ({ myLibrary }) => myLibrary.arrangedplaylistItems.status
  );

  const { isSuccess, message } = useMemo(() => {
    if (updateUserNameStatus === "success") {
      return { isSuccess: true, message: t("successAlerts.usernameUpdated") };
    }
    if (updateEmailStatus === "success") {
      return { isSuccess: true, message: t("successAlerts.emailUpdated") };
    }
    if (setMyEmailPasswordStatus === "success") {
      return {
        isSuccess: true,
        message: t("successAlerts.emailPasswordSet"),
      };
    }
    if (changMyPasswordStatus === "success") {
      return { isSuccess: true, message: t("successAlerts.passwordChanged") };
    }
    if (linkGoogleStatus === "success") {
      return {
        isSuccess: true,
        message: t("successAlerts.googleLinked"),
      };
    }

    if (removeDownloadsStatus.status === "success") {
      return {
        isSuccess: true,
        message: t("successAlerts.downloadsRemoved"),
      };
    }

    if (linkAppleStatus === "success") {
      return {
        isSuccess: true,
        message: t("successAlerts.appleLinked"),
      };
    }

    if (createPlaylistStatus === "success") {
      return {
        isSuccess: true,
        message: t("successAlerts.playlistAdded"),
      };
    }
    if (addItemToPlaylistStatus === "success") {
      return {
        isSuccess: true,
        message: t("successAlerts.itemAddedToplaylist"),
      };
    }
    if (arrangePlaylistItemsStatus === "success") {
      return {
        isSuccess: true,
        message: t("successAlerts.itemRearraggedInplaylist"),
      };
    }

    return { isSuccess: false, message: "" };
  }, [
    updateUserNameStatus,
    updateEmailStatus,
    setMyEmailPasswordStatus,
    changMyPasswordStatus,
    linkGoogleStatus,
    linkAppleStatus,
    removeDownloadsStatus,
    createPlaylistStatus,
    addItemToPlaylistStatus,
    arrangePlaylistItemsStatus,
    t,
  ]);

  return { isSuccess, message };
};
